<template>
    <div class="containers">
        <div class="info-content flex">
            <div class="info-left flex3 flex">
                <div class="info-back flex shrink0">
                    <span class="back-size" @click="$router.back()"><i class="el-icon-back"></i>返回</span>
                </div>
                <div class="info-content-left ml--100">
                    <el-descriptions :column="2">
                        <el-descriptions-item label="公司名称">{{ detail.enterpriseName }}</el-descriptions-item>
                        <el-descriptions-item label="车牌号码">{{ detail.vehicleNumber }}</el-descriptions-item>
                        <el-descriptions-item label="车牌颜色">{{ detail.licensePlateColor }}</el-descriptions-item>
                        <el-descriptions-item label="车辆营运类型">{{ detail.operateType }}</el-descriptions-item>
                        <el-descriptions-item label="所属车主">{{ detail.driverName }}</el-descriptions-item>
                        <el-descriptions-item label="联系电话">{{ detail.driverPhone }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="经营区域">{{ detail.operatingArea }}</el-descriptions-item> -->
                        <!-- <el-descriptions-item label="车辆年度审验">{{ detail.annualReviewStatus }}</el-descriptions-item> -->
                        <el-descriptions-item label="驾驶证" v-if="detail.drivingLicense">
                            <img class="img-size" :src="detail.drivingLicense"></img>
                        </el-descriptions-item>
                        <el-descriptions-item label="行驶证" v-if="detail.travelLicense">
                            <img class="img-size" :src="detail.travelLicense"></img>
                        </el-descriptions-item>
                    </el-descriptions>
                    <!-- <div class="info-btn" @click="showDetail">
                        车辆详细信息<i class="el-icon-arrow-right"></i>
                    </div> -->
                </div>
            </div>
            <div class="info-right flex2" style="margin-top: 40px;">
                <div id="hstplayer" v-if="IsHai == 1" style="width: 100%; height: 100%;"></div>
                <div id="divPlugin" class="divPlugin" ref="divPlugin" v-if="IsHai == 2">
                </div>
                <div style="position: relative; width: 100%; height: 330px" v-if="IsHai == 3">
                    <div
                        style="width: 100%; height: 330px; border-radius: 9px; background: #f5f5f5; display: flex; justify-content: center; align-items: center; flex-direction: column">
                        <video style="width: 100%;border-radius: 9px; display: none" id="monitoringCard"
                            ref="monitoringCard" :controls="false" autoplay>
                        </video>
                        <el-empty description="暂无视频信息" :image-size="80"></el-empty>
                    </div>
                    <canvas id="myCanvas" style="display:none"></canvas>
                    <el-button type="default" style="position: absolute; top: 20px;right: 60px;"
                        @click="goBack()">查看回放</el-button>
                    <div style="position: absolute; right: 11px; top: 20px">
                        <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;
              background: #ffffff; padding: 3px 10px; border-radius: 6px;margin-bottom: 10px;" @click="fullScreen()">
                            <img style="width: 20px; height: 20px" :src="require('../../assets//homeImg/full.png')" />
                            <div
                                style="font-size: 12px;font-weight: 400; line-height: 17px; color: rgba(0, 0, 0, 0.88);">
                                全屏</div>
                        </div>
                        <div style="display: flex;flex-direction: column;align-items: center; justify-content: center;
              background: #ffffff;padding: 3px 10px;border-radius: 6px;" @click="shotScreen()">
                            <img style="width: 20px; height: 20px" :src="require('../../assets//homeImg/slot.png')" />
                            <div
                                style="font-size: 12px; font-weight: 400; line-height: 17px; color: rgba(0, 0, 0, 0.88);">
                                截屏</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content ml--100 mr--30">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="订单记录" name="first">
                    <div class="table-box mt--23">
                        <el-table :data="tableData" border stripe style="width: 100%">
                            <el-table-column type="index" width="80" label="序号"></el-table-column>
                            <el-table-column prop="code" label="订单编号"></el-table-column>
                            <el-table-column prop="vehicleNumber" label="车牌号"></el-table-column>
                            <el-table-column prop="licensePlateColor" label="车牌颜色"></el-table-column>
                            <el-table-column prop="enterpriseName" label="车辆所属公司"></el-table-column>
                            <el-table-column prop="boardingPoint" label="上车地点"></el-table-column>
                            <el-table-column prop="dropOffPoint" label="下车地点"></el-table-column>
                            <el-table-column prop="passengerMileage" label="载客里程"></el-table-column>
                            <el-table-column prop="driverName" label="驾驶员姓名"></el-table-column>
                            <el-table-column prop="driverPhone" label="驾驶员电话"></el-table-column>
                            <el-table-column prop="orderDeliveryTime" label="派单时间"></el-table-column>
                            <el-table-column prop="orderAmount" label="订单金额"></el-table-column>
                            <el-table-column prop="option" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="showDetails(scope.row)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <div class="pagination-box relative mt--23 flex j-end">
                            <el-pagination :popper-append-to-body="false" @size-change="handleSizeChange"
                                @current-change="handleCurrentChange" :current-page="searchForm.pageCurr" background
                                layout="total,sizes,prev, pager, next,jumper" :total="searchForm.total">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="预警记录" name="second">
                    <div class="table-box mt--23">
                        <el-table :data="tableData" border stripe style="width: 100%">
                            <el-table-column type="index" label="序号" fixed width="80"></el-table-column>
                            <el-table-column prop="carName" label="车辆名称" width="120" fixed></el-table-column>
                            <el-table-column prop="vehicleNumber" label="车牌号码" width="120" fixed></el-table-column>
                            <el-table-column prop="keepWarn" label="持续报警" width="120"></el-table-column>
                            <el-table-column prop="name" label="近15分钟情况">
                                <template #default="{ row }">
                                    <img src="@/assets/homeImg/eye-fill.png" alt="" @click="viewDetail(row)"
                                        style="width: 30px;cursor: pointer;">
                                </template>
                            </el-table-column>
                            <el-table-column prop="driverName" label="驾驶员名称" width="120"></el-table-column>
                            <el-table-column prop="enterpriseName" label="所属公司" width="120"></el-table-column>
                            <el-table-column prop="terminalNumber" label="终端编号" width="120"></el-table-column>
                            <el-table-column prop="startTime" label="开始报警时间" width="120"></el-table-column>
                            <el-table-column prop="endTime" label="结束报警时间" width="120"></el-table-column>
                            <el-table-column prop="keepTime" label="持续时长" width="120"></el-table-column>
                            <el-table-column prop="keepDistance" label="持续里程数" width="120"></el-table-column>
                            <el-table-column prop="warnType" label="报警类型" width="120"></el-table-column>
                            <el-table-column prop="warnNumber" label="报警次数" width="120"></el-table-column>
                            <el-table-column prop="treatmentState" label="处理状态" width="120"></el-table-column>
                            <el-table-column prop="treatmentUser" label="处理人" width="120"></el-table-column>
                            <el-table-column prop="treatmentTime" label="处理时间" width="120"></el-table-column>
                            <el-table-column prop="treatmentRemark" label="处理描述" width="240"></el-table-column>
                        </el-table>

                        <div class="pagination-box relative mt--23 flex j-end">
                            <el-pagination :popper-append-to-body="false" @size-change="handleSizeChange"
                                @current-change="handleCurrentChange" :current-page="searchForm.pageCurr" background
                                layout="total,sizes,prev, pager, next,jumper" :total="searchForm.total">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="行驶轨迹" name="third">
                    <div class="form flex j-between mt--23" style="align-items: end;">
                        <div class="form-left ml--30">
                            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                                <el-form-item label="选择轨迹时间范围:" prop="level" class="unset_m"
                                    style="margin-right: 15px;">
                                    <el-date-picker :value-format="'yyyy-MM-dd HH:mm:ss'" v-model="searchForm.date"
                                        type="datetimerange" range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="form-right shrink0 mr--24 mb--23">
                            <el-button class="search-button h--40 w--90 fs--14" icon="el-icon-search" type="primary"
                                size="small" @click="search">查询</el-button>
                            <el-button @click="reset" icon="el-icon-refresh-right"
                                class="reset-button h--40 w--90 fs--14" size="small">重置</el-button>
                        </div>

                    </div>
                    <div class="mapContainer" id="mapContainer"></div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <DetailModal ref="detailModal" :detail="detail" />
        <DetailOrderModal ref="detailOrder" />
        <el-drawer :visible.sync="drawer" append-to-body :size="450" @close="closeDrawer">
            <div class="flex j-between a-center fs--20 pl--15 pr--15">
                <!-- 使用 Tailwind CSS 的内联十六进制颜色类 -->
                <div>{{ info.vehicleNumber }}<span v-if="info.warnList && info.warnList.length > 0">（{{
                    info.warnList.length
                        }}）</span></div><i @click="closeDrawer" class="el-icon-s-unfold color1 pointer"></i>
            </div>
            <hr class="mt--10" />
            <div class="pl--15 pr--15">
                <div class="flex mt--15">
                    <div class="w--100 shrink0 color1">当前司机：</div>
                    <div class="color2">{{ info.driverName }}</div>
                </div>
                <div class="flex mt--15">
                    <div class="w--100 shrink0 color1">当前车速：</div>
                    <div class="color2">{{ info.speed }}km/h</div>
                </div>
                <div class="flex mt--15">
                    <div class="w--100 shrink0 color1">当前位置：</div>
                    <div class="color2">{{ info.nowAddress }}</div>
                </div>
                <div v-if="info.imageUrl" class="flex mt--15">
                    <div class="w--100 shrink0 color1">抓拍照片：</div>
                    <el-image style="height: 100px" :src="info.imageUrl" :preview-src-list="[info.imageUrl]">
                    </el-image>
                </div>
            </div>
            <hr class="mt--10" />
            <div class="flex j-between a-center fs--15 pl--15 pr--15 mt--15 color2">
                近15分钟报警
            </div>
            <div class="block pl--15 pr--15 mt--15">
                <el-timeline>
                    <el-timeline-item v-for="(item, index) in info.warnList" :key="index" color='#0E6EFD'
                        :timestamp="item.warnTime" placement="top">
                        <div @click="initMap1(item)">
                            <el-card class="pointer">
                                <h4>{{ item.warnType }}</h4>
                                <p class="color1">{{ item.speed }}km/h</p>
                            </el-card>
                        </div>

                    </el-timeline-item>
                </el-timeline>
            </div>
            <div v-if="showWarnDetail" class="fixed">
                <div class="card">
                    <div class="title fs--18 color2">视频信号遮挡报警</div>
                    <div id="mapContainers"></div>
                    <div class="">
                        <div class="flex mt--15">
                            <div class="w--100 shrink0 color1">司机：</div>
                            <div class="color2">{{ info.driverName }}</div>
                        </div>
                        <div class="flex mt--15">
                            <div class="w--100 shrink0 color1">车速：</div>
                            <div class="color2">{{ activeInfo.speed }}km/h</div>
                        </div>
                        <div class="flex mt--15">
                            <div class="w--100 shrink0 color1">时间：</div>
                            <div class="color2">{{ activeInfo.warnTime }}</div>
                        </div>
                        <div class="flex mt--15">
                            <div class="w--100 shrink0 color1">地点：</div>
                            <div class="color2">{{ activeInfo.address }}</div>
                        </div>

                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import DetailModal from "./components/detailModal.vue";
import DetailOrderModal from "./components/detailOrderModal.vue";
import { getCarDetail, getCarOrder, getCarWarning, getCarTrack, getCarVideo, getDetail, getOrderInfo, getOrderTravel, getOrderMonitoring, playDetection, closeRealVideo } from './service'
import '../../utils/css/swfobject-h5.css'
import '../../utils/css/DPlayer.min.css'
import moment from "moment";
import flvjs from "flv.js";
export default {
    name: "detail",
    components: { DetailModal, DetailOrderModal },
    data() {
        return {
            id: '',
            tableData: [],
            searchForm: {
                pageCurr: 1,
                pageSize: 10,
                total: 0,
                date: undefined,
            },
            detail: {},
            activeName: 'first',
            routeList: [],
            videoObj: {},
            loading: false,
            drawer: false,
            showWarnDetail: false,
            info: {},
            activeInfo: {},
            map: null,
            carId: null,
            tokenID: 'shehongchuzu',
            plugin: true,
            oWebControl: null,   //插件对象
            initCount: 0,
            pubKey: '',         //公钥加密
            video_init_data: {
                appkey: '27273246',
                appSecret: 'vjvZA7X4hHUc0SbONht9',
                ip: '112.18.106.230',
                port: '443',
                snapDir: 'D:\\SnapDir',
                videoDir: 'D:\\VideoDir',
                layout: '1x1',
                encryptedFields: 'secret',
                enableHttps: '1',
            },
            video_play_data: {
                cameraIndexCode: '',
                streamMode: 0,
                transMode: 1,
                gpuMode: 0,
                wndId: -1,
            },
            //videoWidth videoHeight screenWidth screenHeight 
            //这四个参数为了使插件大小和屏幕宽度一致变化
            videoWidth: 700,
            videoHeight: 500,
            screenWidth: document.documentElement.clientWidth,//屏幕宽度
            screenHeight: document.documentElement.clientHeight,//屏幕高度
            //设置窗口遮挡 根据浏览器大小变化视频插件的大小
            iLastCoverLeft: 0,
            iLastCoverTop: 0,
            iLastCoverRight: 0,
            iLastCoverBottom: 0,
            IsHai: 1,
        }
    },

    created() {

    },
    mounted() {
        if (this.$route.query.id) {
            this.carId = this.$route.query.id
            getCarDetail({ id: this.$route.query.id }).then(res => {
                this.detail = res;
                this.getList(res.vehicleNumber);
                if (['17235341', '82296583'].includes(res.companyCode)) {
                    this.loadScripts().then(() => {
                        //视频参数
                        var params = {
                            allowFullscreen: "true",
                            allowScriptAccess: "always",
                            bgcolor: "#FFFFFF",
                            wmode: "transparent",
                        };
                        //初始化视频插件
                        this.IsHai = 1;
                        window.hstVideoPlay.init(this.tokenID, "hstplayer", params, 1); // 设置为1个窗口

                        this.$nextTick(() => {
                            setTimeout(() => {
                                hstVideoPlay.realTimeOpenVideo(res.deviceId, '2')
                            }, 1000);
                        })
                    });
                } else if (res.companyCode == '25439966') {
                    this.IsHai = 2;
                    getCarVideo({ id: this.$route.query.id }).then(res => {
                        this.videoObj = res;
                        // this.initVideoPlayer();
                        this.video_play_data.cameraIndexCode = res.url;
                        this.initPlugin();
                        this.$nextTick(() => {
                            this.videoWidth = this.$refs.divPlugin.offsetWidth;
                            this.videoHeight = this.$refs.divPlugin.offsetHeight;
                        })
                        // 监听窗口变化
                        let _this = this;
                        window.onresize = function () { // 定义窗口大小变更通知事件 
                            _this.screenWidth = document.documentElement.clientWidth; //窗口宽度
                            _this.screenHeight = document.documentElement.clientHeight; //窗口高度
                        };
                        window.addEventListener('scroll', function () {
                            if (this.oWebControl != null) {
                                this.oWebControl.JS_Resize(this.videoWidth, this.videoHeight);
                                this.setWndCover();
                            }
                        });
                    })
                } else {
                    this.IsHai = 3;
                    getCarVideo({ id: this.$route.query.id }).then(res => {
                        this.videoObj = res;
                        this.initVideoPlayer();

                    })
                }

            })
        }
    },

    beforeDestroy() {
        this.destroyPlayer();
        if (this.oWebControl != null) {
            this.oWebControl.JS_DestroyWnd();
        }

    },
    watch: {
        screenWidth(n, o) {

        },
        screenHeight(n, o) {
        },
        videoDialog(n) {
            if (n) {
                this.initPlugin();
            }
        },
    },
    methods: {
        initVideoPlayer() {
            // 先销毁之前的播放器
            if (this.flvPlayer) {
                this.flvPlayer.destroy();
                this.flvPlayer = null;
            }

            // 获取video元素
            const video = document.getElementById("monitoringCard");
            if (!video) {
                console.error("Video element not found");
                return;
            }

            // 检查flv.js是否支持
            if (flvjs.isSupported()) {
                try {
                    playDetection(this.$route.query.id).then((res) => {
                        this.flvPlayer = flvjs.createPlayer({
                            type: "flv", //视频类型
                            isLive: true, //是否为直播
                            cors: true, //是否开启跨域
                            hasAudio: false, //是否开启音频
                            hasVideo: true, //是否开启视频
                            // url: `http://${this.videoObj.serverIp}:${this.videoObj.serverPort}/live?port=1935&app=flv&stream=${this.$route.query.id}`, // 后端拿到的视频路径
                            url: this.videoObj.url, // 后端拿到的视频路径
                            enableWorker: true, //启用 Web Worker 进程来加速视频的解码和处理过程
                            enableStashBuffer: false, // 启用数据缓存机制，提高视频的流畅度和稳定性。
                            stashInitialSize: 1024, // 初始缓存大小。单位：字节。建议针对直播：调整为1024kb
                            stashInitialTime: 0.2, // 缓存初始时间。单位：秒。建议针对直播：调整为200毫秒
                            seekType: "range", // 建议将其设置为"range"模式，以便更快地加载视频数据，提高视频的实时性。
                            lazyLoad: false, //关闭懒加载模式，从而提高视频的实时性。建议针对直播：调整为false
                            lazyLoadMaxDuration: 0.2, // 懒加载的最大时长。单位：秒。建议针对直播：调整为200毫秒
                            deferLoadAfterSourceOpen: false, // 不预先加载视频数据，在 MSE（Media Source Extensions）打开后立即加载数据，提高视频的实时性。建议针对直播：调整为false
                        });
                        let video = document.getElementById("monitoringCard");
                        this.flvPlayer.attachMediaElement(video); // video容器
                        this.flvPlayer.load();
                        this.flvPlayer
                            .play()
                            .then((res) => {
                                // 显示视频元素
                                video.style.display = 'block';
                                // 隐藏空状态
                                const emptyElement = video.parentElement.querySelector('.el-empty');
                                if (emptyElement) {
                                    emptyElement.style.display = 'none';
                                }

                                this.videoTimer = setInterval(() => {
                                    playDetection(this.$route.query.id);
                                }, 5000);
                            })
                            .catch((err) => {
                                this.destroyPlayer();
                            });
                        // 错误监听
                        this.flvPlayer.on("error", (err) => {
                            this.destroyPlayer();
                        });
                    });
                } catch (error) {
                    console.log("创建播放器失败:", error);
                }
            } else {
                console.error("当前浏览器不支持flv.js");
            }
        },
        initPlugin() {
            let _this = this
            this.oWebControl = new WebControl({
                szPluginContainer: "divPlugin",
                iServicePortStart: 15900,
                iServicePortEnd: 15909,
                // 用于 IE10 使用 ActiveX 的 clsid
                szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11",
                cbConnectSuccess: (e) => {
                    console.log('连接成功')
                    this.plugin = true;
                    _this.setCallbacks();
                    if (_this.oWebControl) {
                        _this.oWebControl.JS_StartService("window", {
                            dllPath: "./VideoPluginConnect.dll"
                            //dllPath: "./DllForTest-Win32.dll"
                        }).then((res) => {
                            _this.oWebControl.JS_CreateWnd("divPlugin", _this.videoWidth, _this.videoHeight).then(() => {
                                console.log("JS_CreateWnd success");
                                _this.initVideo();
                            });
                        }, function () {
                        });
                    } else {
                    }
                },
                cbConnectError: () => {
                    console.log("cbConnectError");
                    _this.oWebControl = null;
                    $("#divPlugin").html("插件未启动，正在尝试启动，请稍候...");
                    WebControl.JS_WakeUp("VideoWebPlugin://");
                    _this.initCount++;
                    if (_this.initCount < 3) {
                        setTimeout(() => {
                            _this.initPlugin();
                        }, 3000)
                    } else {
                        $("#divPlugin").html("插件启动失败，请检查插件是否安装！");
                        this.plugin = false;
                    }
                },
                cbConnectClose: () => {
                    console.log("cbConnectClose");
                    this.oWebControl.JS_Disconnect().then(function () { }, function () { });
                    this.oWebControl = null;
                }
            });
        },
        // 设置窗口控制回调
        setCallbacks() {
            this.oWebControl.JS_SetWindowControlCallback({
                cbIntegrationCallBack: this.cbIntegrationCallBack
            });
        },
        // 推送消息
        cbIntegrationCallBack(oData) {
            this.$message.warning((JSON.stringify(oData.responseMsg)));
        },
        // 初始化参数
        initVideo() {
            this.getPubKey(() => {
                let appkey = this.video_init_data.appkey;
                let secret = this.setEncrypt(this.video_init_data.appSecret);
                let ip = this.video_init_data.ip;
                let szPort = this.video_init_data.port;
                let snapDir = this.video_init_data.snapDir;
                let videoDir = this.video_init_data.videoDir;
                let layout = this.video_init_data.layout;
                let encryptedFields = ['secret'];

                appkey = appkey.replace(/(^\s*)/g, "");
                appkey = appkey.replace(/(\s*$)/g, "");

                secret = secret.replace(/(^\s*)/g, "");
                secret = secret.replace(/(\s*$)/g, "");

                ip = ip.replace(/(^\s*)/g, "");
                ip = ip.replace(/(\s*$)/g, "");

                szPort = szPort.replace(/(^\s*)/g, "");
                szPort = szPort.replace(/(\s*$)/g, "");

                snapDir = snapDir.replace(/(^\s*)/g, "");
                snapDir = snapDir.replace(/(\s*$)/g, "");

                videoDir = videoDir.replace(/(^\s*)/g, "");
                videoDir = videoDir.replace(/(\s*$)/g, "");

                let port = parseInt(szPort);
                let enableHttps = parseInt(this.video_init_data.enableHttps);

                encryptedFields = encryptedFields.join(",");
                this.oWebControl.JS_RequestInterface({
                    funcName: "init",
                    argument: JSON.stringify({
                        appkey: appkey,
                        secret: secret,
                        ip: ip,
                        playMode: 0, // 预览
                        port: port,
                        snapDir: snapDir,
                        videoDir: videoDir,
                        layout: layout,
                        enableHTTPS: enableHttps,
                        encryptedFields: encryptedFields
                    })
                }).then((res) => {
                    console.log('初始化成功')
                    this.oWebControl.JS_Resize(this.videoWidth, this.videoHeight);
                    this.setWndCover();
                    this.startRealPlay();
                });
            })
        },
        // 获取公钥
        getPubKey(callback) {
            this.oWebControl.JS_RequestInterface({
                funcName: "getRSAPubKey",
                argument: JSON.stringify({
                    keyLength: 1024
                })
            }).then((oData) => {
                // console.log(oData)
                if (oData.responseMsg.data) {
                    this.pubKey = oData.responseMsg.data
                    callback()
                }
            })
        },
        // RSA加密
        setEncrypt(value) {
            if (!this.pubKey) {
                console.log('请先获取公钥')
                return
            }
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(this.pubKey);
            return encrypt.encrypt(value);
        },
        // 视频预览
        startRealPlay(IndexCode) {
            console.log('------开始播放-------')
            let cameraIndexCode = IndexCode ? IndexCode : this.video_play_data.cameraIndexCode;
            let streamMode = this.video_play_data.streamMode;
            let transMode = this.video_play_data.transMode;
            let gpuMode = this.video_play_data.gpuMode;
            let wndId = -1;  //默认为空闲窗口回放

            cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, "");
            cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, "");
            this.oWebControl.JS_RequestInterface({
                funcName: "startPreview",
                argument: JSON.stringify({
                    cameraIndexCode: cameraIndexCode,
                    streamMode: streamMode,
                    transMode: transMode,
                    gpuMode: gpuMode,
                    wndId: wndId
                })
            }).then(function (oData) {
                console.log('播放成功')
            });
        },
        //根据窗口变化设置视频插件大小
        resizewindow(w, h) {
            console.log('resize')
            w = (w < 1423) ? 1423 : w
            h = (h < 754) ? 754 : h
            window.resizeTo(w, h);
        },
        //设置窗口遮挡
        setWndCover() {
            console.log("setWndCover", this.oWebControl);

            let iWidth = document.body.clientWidth;
            let iHeight = document.body.clientHeight;
            let oDivRect = document.getElementById("divPlugin").getBoundingClientRect();
            let iCoverLeft = (oDivRect.left < 0) ? Math.abs(oDivRect.left) : 0;
            let iCoverTop = (oDivRect.top < 0) ? Math.abs(oDivRect.top) : 0;
            let iCoverRight = (oDivRect.right - iWidth > 0) ? Math.round(oDivRect.right - iWidth) : 0;
            let iCoverBottom = (oDivRect.bottom - iHeight > 0) ? Math.round(oDivRect.bottom - iHeight) : 0;
            console.log("iCoverLeft", iWidth, iHeight, oDivRect, iCoverLeft, iCoverTop, iCoverRight, iCoverBottom);

            iCoverLeft = (iCoverLeft > 700) ? 700 : iCoverLeft;
            iCoverTop = (iCoverTop > 400) ? 400 : iCoverTop;
            iCoverRight = (iCoverRight > 700) ? 700 : iCoverRight;
            iCoverBottom = (iCoverBottom > 400) ? 400 : iCoverBottom;
            if (this.iLastCoverLeft != iCoverLeft) {
                console.log("iCoverLeft: " + iCoverLeft);
                this.iLastCoverLeft = iCoverLeft;
                this.oWebControl.JS_SetWndCover("left", iCoverLeft);
            }
            if (this.iLastCoverTop != iCoverTop) {
                console.log("iCoverTop: " + iCoverTop);
                this.iLastCoverTop = iCoverTop;
                this.oWebControl.JS_SetWndCover("top", iCoverTop);
            }
            if (this.iLastCoverRight != iCoverRight) {
                console.log("iCoverRight: " + iCoverRight);
                this.iLastCoverRight = iCoverRight;
                this.oWebControl.JS_SetWndCover("right", iCoverRight);
            }
            if (this.iLastCoverBottom != iCoverBottom) {
                console.log("iCoverBottom: " + iCoverBottom);
                this.iLastCoverBottom = iCoverBottom;
                this.oWebControl.JS_SetWndCover("bottom", iCoverBottom);
            }
        },
        //关闭所有的播放画面   
        close_all() {
            this.oWebControl.JS_RequestInterface({
                funcName: "stopAllPreview"
            }).then(function (oData) {
                console.log(JSON.stringify(oData ? oData.responseMsg : ''))
            });
        },
        loadScripts() {
            return new Promise((resolve, reject) => {
                const scripts = [
                    '/scripts/jquery-1.7.1.min.js',
                    '/scripts/md5.js',
                    '/scripts/request.js',
                    '/scripts/swfobject-all.js',
                    '/scripts/swfobject-play.js',
                    '/scripts/swfobject-h5.js',
                    '/scripts/flv.min.js',
                    '/scripts/DPlayer.min.js',
                    '/scripts/HZPlayer.js',
                    '/scripts/HZRecorder.js'
                ];

                const loadScript = (index) => {
                    if (index >= scripts.length) {
                        resolve();
                        return;
                    }

                    const script = document.createElement('script');
                    script.src = scripts[index];
                    script.onload = () => loadScript(index + 1);
                    script.onerror = reject;
                    document.head.appendChild(script);
                };

                loadScript(0);
            });
        },
        goBack() {
            this.$router.push('/car-playback?id=' + this.$route.query.id)
        },

        destroyPlayer() {
            if (this.$route.query.id) {
                window.hstVideoPlay.historyCloseVideo(this.$route.query.id, '1');
            }
              // 销毁播放器释放资源
              if (this.flvPlayer) {
                if (this.videoTimer) clearInterval(this.videoTimer);
                closeRealVideo(this.carId).then((res) => {
                    this.flvPlayer.pause();
                    this.flvPlayer.unload();
                    this.flvPlayer.detachMediaElement();
                    this.flvPlayer.destroy();
                    this.flvPlayer = null;

                    // 恢复空状态的显示
                    const video = document.getElementById("monitoringCard");
                    if (video) {
                        video.style.display = 'none';
                        const emptyElement = video.parentElement.querySelector('.el-empty');
                        if (emptyElement) {
                            emptyElement.style.display = 'block';
                        }
                    }
                });
            }
        },
          // 处理视频错误
          handleVideoError(event) {
            console.error("视频加载失败", event);
            if (this.flvPlayer) {
                this.flvPlayer.destroy();
                this.flvPlayer = null;
            }
            this.infoWindow.setContent(
                '<div style="padding: 20px;text-align: center;color: red;">视频加载失败，请稍后重试</div>'
            );
        },
        
        shotScreen() {
            // 获取video和canvas元素
            const video = document.getElementById("monitoringCard");
            const canvas = document.getElementById("myCanvas");
            // 设置canvas的宽度和高度与video相同
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            // 获取canvas的2d绘图上下文
            const context = canvas.getContext("2d");
            // 将当前video帧绘制到canvas上
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            setTimeout(() => {
                // 将canvas内容转换为图片
                let dataURL = canvas.toDataURL("image/png");
                this.downloadImage(dataURL);
            }, 100);
        },
        downloadImage(base64) {
            const link = document.createElement("a");
            link.href = base64;
            link.download = "screenshot.png"; // 你希望下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        fullScreen() {
            const video = document.getElementById("monitoringCard");
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if (video.mozRequestFullScreen) {
                // Firefox
                video.mozRequestFullScreen();
            } else if (video.webkitRequestFullscreen) {
                // Chrome, Safari and Opera
                video.webkitRequestFullscreen();
            } else if (video.msRequestFullscreen) {
                // IE/Edge
                video.msRequestFullscreen();
            }
        },
        showDetails(row) {
            this.loading = true
            Promise.all([getOrderInfo(row.id), getOrderTravel({ id: row.id })]).then(res => {
                // getOrderMonitoring({ id: row.id }).then(resp => {
                //     this.$refs.detailOrder.initData(res[0], resp, res[1])
                //     this.loading = false
                // }).catch(err => {
                this.$refs.detailOrder.initData(res[0], {}, res[1])
                this.loading = false
                // })
            }).catch(err => {
                this.loading = false
            })
        },
        closeDrawer() {
            this.drawer = false
            this.showWarnDetail = false

        },
        // 查看详情
        viewDetail(row) {
            this.drawer = true
            getDetail({ vehicleNumber: row.vehicleNumber }).then(res => {
                this.info = res
            })
        },
        // 初始化地图
        initMap1(row) {
            this.showWarnDetail = true
            this.activeInfo = row
            this.$nextTick(() => {
                window._AMapSecurityConfig = {
                    securityJsCode: this.$secretKey,
                };
                AMapLoader.load({
                    key: this.$mapKey,
                    version: "2.0",
                    plugins: [
                        "AMap.ToolBar",
                        "AMap.AutoComplete",
                        "AMap.Geocoder",
                        "AMap.MarkerCluster",
                    ],
                })
                    .then((AMap) => {
                        this.map = new AMap.Map("mapContainers", {
                            center: [row.lon, row.lat],
                            zoom: 15,
                        });

                        // 添加标记
                        new AMap.Marker({
                            position: [row.lon, row.lat],
                            map: this.map,
                            title: row.warnType
                        });
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            })
        },
        handleClick(e) {
            this.activeName = e.name
            if (e.name != 'third') {
                this.searchForm = {
                    pageCurr: 1,
                    pageSize: 10,
                    total: 0,
                }

                this.getList(this.detail.vehicleNumber)
                //销毁地图
                if (this.map) {
                    this.map.destroy();
                }
            } else {
                getCarTrack({ ...this.searchForm, vehicleNumber: this.detail.vehicleNumber }).then(res => {
                    this.routeList = res;
                    if (res.length > 0) {
                        this.initMap();
                    }
                })
            }
        },
        search() {
            if (this.searchForm.date != undefined) {

                this.searchForm = {
                    pageCurr: 1,
                    pageSize: 10,
                    total: 0,
                    startTime: new Date(this.searchForm.date[0]).getTime() / 1000,
                    endTime: new Date(this.searchForm.date[1]).getTime() / 1000,
                }
                getCarTrack({ ...this.searchForm, vehicleNumber: this.detail.vehicleNumber }).then(res => {
                    this.routeList = res;
                    if (res.length > 0) {
                        this.initMap();
                    }
                })
            }

        },
        reset() {
            this.searchForm = {
                pageCurr: 1,
                pageSize: 10,
                total: 0,
                date: undefined,
            }
        },
        getList(vehicleNumber) {
            if (this.activeName == 'first') {
                getCarOrder({ ...this.searchForm, vehicleNumber: vehicleNumber }).then(res => {
                    this.tableData = res.records;
                    this.searchForm.total = res.total;
                })
            } else {
                getCarWarning({ ...this.searchForm, vehicleNumber: vehicleNumber }).then(res => {
                    this.tableData = res.records;
                    this.searchForm.total = res.total;
                })
            }
        },


        showDetail() {
            this.$refs.detailModal.dialogVisible = true
        },
        initMap() {
            window._AMapSecurityConfig = {
                securityJsCode: this.$secretKey,
            };
            AMapLoader.load({
                key: this.$mapKey,
                version: "2.0",
                plugins: [
                    "AMap.ToolBar",
                ],
            })
                .then((AMap) => {
                    this.map = new AMap.Map("mapContainer", {
                        center: [105.574542, 30.5061493],
                        zoom: 15,
                    });
                    this.map.addControl(new AMap.ToolBar());

                    let path = []
                    const iconMap = {
                        出租车: {
                            icon: require("../../assets/homeImg/taxi.png"),
                            size: new AMap.Size(75, 37),
                        },
                        公交车: {
                            icon: require("../../assets/homeImg/bus.png"),
                            size: new AMap.Size(62, 34),
                        },
                        危险品: {
                            icon: require("../../assets/homeImg/risk.png"),
                            size: new AMap.Size(69, 32),
                        },
                        郊游: {
                            icon: require("../../assets/homeImg/outing.png"),
                            size: new AMap.Size(61, 31),
                        },
                        货运: {
                            icon: require("../../assets/homeImg/expressage.png"),
                            size: new AMap.Size(60, 31),
                        },
                        网约车: {
                            icon: require("../../assets/homeImg/online.png"),
                            size: new AMap.Size(75, 33),
                        },
                        客运: {
                            icon: require("../../assets/homeImg/passenger.png"),
                            size: new AMap.Size(69, 31),
                        },
                    };

                    this.routeList.forEach(item => {
                        path.push(new AMap.LngLat(item.longitude, item.latitude))
                    })

                    const content = `<div class="custom-content-marker">
                                        <img src="${iconMap[this.detail.operateType].icon}">
                                    </div>`;
                    const marker = new AMap.Marker({
                        content: content, //自定义点标记覆盖物内容
                        position: [105.57, 30.51], //基点位置
                        offset: new AMap.Pixel(-30, -15), //相对于基点的偏移位置
                        size: iconMap[this.detail.operateType].size,
                    });
                    this.map.add(marker);
                    let polyline = new AMap.Polyline({
                        path: path,
                        strokeWeight: 2, //线条宽度
                        strokeColor: "red", //线条颜色
                        lineJoin: "round", //折线拐点连接处样式
                    });
                    this.map.add(polyline);
                })
                .catch((e) => {
                });
        },
        handleSizeChange(e) {
            this.searchForm.pageSize = e
        },
        handleCurrentChange(e) {
            this.searchForm.page = e
        },
        // getDetail() {
        //     this.$axios.get(`/api/complaint/detail/${this.id}`).then(res => {
        //         console.log(res);
        //     })
        // }
    },
}
</script>
<style scoped lang="less">
.divPlugin {
    width: 80%;
    height: 400px;
    color: red;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
}

.down {
    width: 100%;
    height: 100%;
    color: red;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;

    a {
        color: red;
    }
}

.video-player {
    width: 100%;
    height: 100%;


}

.containers {
    height: 100vh;
    overflow-y: auto;
}

.info-back {
    cursor: pointer;
    // flex-shrink: ;
}

.info-content {
    padding: 30px;
    height: 600px;
    margin-bottom: 30px;
}

::v-deep .el-descriptions-item__container {
    font-size: 18px;

    .el-descriptions-item__label {
        font-weight: 600;
    }

    .el-descriptions-item__content {
        width: 200px;
    }
}

.img-size {
    width: 169px;
    height: 99px;
}

.info-btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.info-btn {
    font-size: 18px;
    color: #0E6EFD;
    cursor: pointer;
    margin-top: 60px;
}

.flex3 {
    flex: 3;
}

.flex2 {
    flex: 2;
}

.back-size {
    font-size: 24px;
    color: #0E6EFD;
    cursor: pointer;
}

#mapContainer {
    width: 100%;
    height: 600px;
}

#mapContainers {
    width: 100%;
    height: 500px;
    margin: 20px 0;
}

::v-deep .el-drawer__body {
    position: relative;

    .fixed {
        right: 470px;
        top: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        align-items: center;

        .card {
            background: #fff;
            width: 500px;
            max-height: 1000px;
            padding: 15px;
        }
    }
}

.color1 {
    color: #0E6EFD;
}

.color2 {
    color: rgb(52, 52, 52);
}

::v-deep .pagination-popper {
    position: fixed !important;
    transform:
        scale(calc(1 / var(--scale))) translate(calc(100px * (1 - 1 / var(--scale))),
            calc(5px * (1 - 1 / var(--scale)))) !important;
    transform-origin: right top !important;
    right: calc(30px * (1 - 1 / var(--scale))) !important;
    margin-top: 5px;
    min-width: 100px !important;
}
</style>